<template>
  <div class="prayer-container">
    <div class="row">
      <div class="col-3 mb-3 p-0" v-for="(prayer,idx) in prayers" :key="idx">
        <Prayer :prayer="prayer" :active="prayer.id in activePrayers" @stateChange="setActive"></Prayer>
      </div>
    </div>
  </div>
</template>

<script>
  import Prayer from "./Prayer";

  export default {
    name: "PrayerContainer",
    components: {Prayer},
    props: {
      activePrayers: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        prayers: {}
      }
    },
    methods: {
      // getPrayers: function () {
      //   let uri = 'https://www.osrsbox.com/osrsbox-db/prayers-complete.json';
      //
      //   this.$http.get(uri).then((resp) => {
      //     if (resp.status !== 200) {
      //       //TODO ERR
      //     }
      //     console.log('prayers', resp.data);
      //     this.prayers = Object.keys(resp.data).filter((key) => {
      //       return this.isEmpty(resp.data[key].bonuses);
      //     }).map((key) => {
      //       return resp.data[key];
      //     });
      //   })
      // },

      getPrayers: function() {
        const prayers = require('@/assets/data/prayers/default.json');
        this.prayers = Object.keys(prayers).filter((key) => {
          return this.isEmpty(prayers[key].bonuses);
        }).map((key) => {
          return prayers[key];
        });
      },

      setActive(prayer, state) {
        //TODO Rules around the prayers being turned on (turn other prayers off)


        if(state) {
          this.$set(this.activePrayers, prayer.id, prayer);
        } else {
          this.$delete(this.activePrayers, prayer.id);
        }
        this.$emit('stateChanged', prayer, state)
      },
      isEmpty: function (obj) {
        return Object.keys(obj).length;
      }
    },
    mounted() {
      this.getPrayers();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tabs/prayer/PrayerContainer.vue